// import { useEffect, useState } from "react";
// import DashboardLayout from "../../layouts/DashboardLayout";
// import {
//   getAttendance,
//   deleteAttendance,
// } from "../../services/attendanceService";
// import { useNavigate } from "react-router-dom";
// import { updateAttendanceStatus } from "../../services/attendanceService";
// import "./Attendance.css";

// export default function Attendance() {
//   const [attendance, setAttendance] = useState([]);

//   useEffect(() => {
//     loadAttendance();
//   }, []);

//   const loadAttendance = async () => {
//     const data = await getAttendance();

//     setAttendance(data);
//   };

//   const handleDelete = async (id) => {
//     await deleteAttendance(id);

//     loadAttendance();
//   };
//   const navigate = useNavigate();
//   const handleStatusChange = async (id, status) => {
//     try {
//       await updateAttendanceStatus(id, status);

//       loadAttendance();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <DashboardLayout>
//       <div className="attendance-header">
//         <div>
//           <h1>Attendance Management</h1>
//           <p style={{ fontWeight: "bold", color: "white" }}>
//             Monitor member attendance and track daily gym activity.
//           </p>
//         </div>

//         <button className="add-btn" onClick={() => navigate("/attendance/add")}>
//           + Mark Attendance
//         </button>
//       </div>
//       <div className="attendance-table-card">
//         <table className="member-table">
//           <thead>
//             <tr>
//               <th>Member ID</th>
//               <th>Member</th>
//               <th>Date</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {attendance.length > 0 ? (
//               attendance.map((item) => (
//                 <tr key={item.id}>
//                   <td>
//                     <strong>{item.memberId || "-"}</strong>
//                   </td>

//                   <td>{item.memberName || "-"}</td>

//                   <td>{item.date || "-"}</td>

//                   <td>
//                     <select
//                       className={`attendance-status ${
//                         item.status === "Present"
//                           ? "status-present"
//                           : "status-absent"
//                       }`}
//                       value={item.status}
//                       onChange={(e) =>
//                         handleStatusChange(item.id, e.target.value)
//                       }
//                     >
//                       <option value="Present">Present</option>

//                       <option value="Absent">Absent</option>
//                     </select>
//                   </td>

//                   <td>
//                     <button
//                       className="delete-btn"
//                       onClick={() => handleDelete(item.id)}
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="5">No attendance records found.</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </DashboardLayout>
//   );
// }

import { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";

import {
  getAttendance,
  deleteAttendance,
  updateAttendanceStatus,
} from "../../services/attendanceService";

import { getMembers } from "../../services/memberService";

import { useNavigate } from "react-router-dom";

import "./Attendance.css";

export default function Attendance() {
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    loadAttendance();
  }, []);

  const loadAttendance = async () => {
    try {
      setLoading(true);

      // Get attendance
      const attendanceData = await getAttendance();

      // Get members
      const membersData = await getMembers();

      // Match attendance with member
      const updatedAttendance = attendanceData.map((attendanceItem) => {
        const member = membersData.find(
          (memberItem) =>
            memberItem.memberId === attendanceItem.memberId ||
            memberItem.fullName?.toLowerCase() ===
              attendanceItem.memberName?.toLowerCase(),
        );

        return {
          ...attendanceItem,

          memberId: member?.memberId || attendanceItem.memberId || "-",

          memberPhoto: member?.photo || member?.photoBase64 || "",

          memberName: member?.fullName || attendanceItem.memberName || "-",
        };
      });

      setAttendance(updatedAttendance);
    } catch (error) {
      console.error("Attendance loading error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteAttendance(id);
      await loadAttendance();
    } catch (error) {
      console.error("Delete attendance error:", error);
    }
  };

  const handleStatusChange = async (id, status) => {
    try {
      await updateAttendanceStatus(id, status);
      await loadAttendance();
    } catch (error) {
      console.error("Status update error:", error);
    }
  };

  // =========================================================
  // GROUP ATTENDANCE BY DATE
  // =========================================================

  const groupedAttendance = attendance.reduce((groups, item) => {
    const date = item.date || "Unknown Date";

    if (!groups[date]) {
      groups[date] = [];
    }

    groups[date].push(item);

    return groups;
  }, {});

  // Sort dates newest first
  const sortedDates = Object.keys(groupedAttendance).sort(
    (a, b) => new Date(b) - new Date(a),
  );

  // Format date
  const formatDate = (date) => {
    if (!date || date === "Unknown Date") {
      return "Unknown Date";
    }

    const dateObject = new Date(date);

    return dateObject.toLocaleDateString("en-IN", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <DashboardLayout>
      <div className="attendance-page">
        {/* =====================================================
            HEADER
        ===================================================== */}

        <div className="attendance-header">
          <div>
            <h1>Attendance Management</h1>

            <p style={{ fontWeight: "bold", color: "white" }}>
              Monitor member attendance and track daily gym activity.
            </p>
          </div>

          <button
            className="add-btn"
            onClick={() => navigate("/attendance/add")}
          >
            + Mark Attendance
          </button>
        </div>

        {/* =====================================================
            LOADING
        ===================================================== */}

        {loading ? (
          <div className="attendance-loading">Loading attendance...</div>
        ) : attendance.length === 0 ? (
          <div className="attendance-empty">
            <h3>No Attendance Records</h3>

            <p>Attendance records will appear here after members check in.</p>
          </div>
        ) : (
          /* ===================================================
             DATE SECTIONS
          =================================================== */

          <div className="attendance-date-sections">
            {sortedDates.map((date) => {
              const dateAttendance = groupedAttendance[date];

              const presentCount = dateAttendance.filter(
                (item) => item.status === "Present",
              ).length;

              const absentCount = dateAttendance.filter(
                (item) => item.status === "Absent",
              ).length;

              return (
                <div className="attendance-date-section" key={date}>
                  {/* =========================================
                      DATE HEADER
                  ========================================= */}

                  <div className="attendance-date-header">
                    <div>
                      <h2>📅 {formatDate(date)}</h2>

                      <span>
                        {dateAttendance.length} Attendance
                        {dateAttendance.length !== 1 ? "s" : ""}
                      </span>
                    </div>

                    <div className="attendance-date-stats">
                      <div className="attendance-stat present">
                        <strong>{presentCount}</strong>
                        <span>Present</span>
                      </div>

                      <div className="attendance-stat absent">
                        <strong>{absentCount}</strong>
                        <span>Absent</span>
                      </div>
                    </div>
                  </div>

                  {/* =========================================
                      TABLE
                  ========================================= */}

                  <div className="attendance-table-card">
                    <table className="member-table">
                      <thead>
                        <tr>
                          <th>Photo</th>
                          <th>Member ID</th>
                          <th>Member</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {dateAttendance.map((item) => (
                          <tr key={item.id}>
                            {/* PHOTO */}

                            <td>
                              {item.memberPhoto ? (
                                <img
                                  src={item.memberPhoto}
                                  alt={item.memberName}
                                  className="attendance-member-photo"
                                />
                              ) : (
                                <div className="attendance-photo-placeholder">
                                  {item.memberName?.charAt(0)?.toUpperCase() ||
                                    "?"}
                                </div>
                              )}
                            </td>

                            {/* MEMBER ID */}

                            <td>
                              <strong>{item.memberId}</strong>
                            </td>

                            {/* MEMBER NAME */}

                            <td>
                              <strong>{item.memberName}</strong>
                            </td>

                            {/* STATUS */}

                            <td>
                              <select
                                className={`attendance-status ${
                                  item.status === "Present"
                                    ? "status-present"
                                    : "status-absent"
                                }`}
                                value={item.status}
                                onChange={(e) =>
                                  handleStatusChange(item.id, e.target.value)
                                }
                              >
                                <option value="Present">Present</option>

                                <option value="Absent">Absent</option>
                              </select>
                            </td>

                            {/* DELETE */}

                            <td>
                              <button
                                className="delete-btn"
                                onClick={() => handleDelete(item.id)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
